export enum ConversationMessageType {
    Text = 1,
    Image,
    Pdf,
    Video,
    Voice,
    Document,
    Location
}